/* unplugin-vue-components disabled */import { render } from "./wv-info.vue?vue&type=template&id=c9e00b9e&scoped=true"
import script from "./wv-info.vue?vue&type=script&lang=js"
export * from "./wv-info.vue?vue&type=script&lang=js"

import "./wv-info.vue?vue&type=style&index=0&id=c9e00b9e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9e00b9e"],['__file',"src/pages/settings/admin/weaviate/wv-info.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9e00b9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9e00b9e', __exports__)) {
    api.reload('c9e00b9e', __exports__)
  }
  
  module.hot.accept("./wv-info.vue?vue&type=template&id=c9e00b9e&scoped=true", () => {
    api.rerender('c9e00b9e', render)
  })

}


export default __exports__